import { render, staticRenderFns } from "./ModelISOYM.vue?vue&type=template&id=18f1da20&scoped=true&"
import script from "./ModelISOYM.vue?vue&type=script&lang=js&"
export * from "./ModelISOYM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f1da20",
  null
  
)

export default component.exports